import React from 'react';
import Icon from '@mdi/react';
import { List, ListItem, Stack } from '@mui/material';
import DateTag from '../../TextBlocks/DateTag';
import GroupedAvatars from '../../GroupedAvatars/GroupedAvatars';
import { mdiCommentTextOutline } from '@mdi/js';
import { vars } from '../../../../Theme';
import { genObjectId } from '../../../../util/HashUtils';
import AppTooltip from '../../AppTooltip/AppTooltip';
import { parseDate } from '../../../../util/DateUtils';

const itemSx = { p: 0, my: 1, borderBottom: '1px solid black' };

export default ({ data }: { data: IActivityLogAssigment[] }) => (
    <List sx={{ p: 0 }}>
        {(data ?? []).map(item => (
            <ListItem key={genObjectId(item)} sx={itemSx}>
                <Stack spacing={1} width='100%'>
                    <Stack direction='row' pl={1} justifyContent='space-between'>
                        <GroupedAvatars data={item.Creator} />
                        <DateTag
                            date={parseDate(item.CreationDate, 'DD.MM.YYYY HH:mm:ss').toISOString()}
                            showTooltipWithTime={true}
                        />
                    </Stack>
                    {item.Description && (
                        <Stack direction='row' spacing={2}>
                            <Icon path={mdiCommentTextOutline} size={1} color={vars.font} />
                            <AppTooltip title={item.Description}>
                                <span
                                    style={{
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {item.Description}
                                </span>
                            </AppTooltip>
                        </Stack>
                    )}
                </Stack>
            </ListItem>
        ))}
    </List>
);

export interface IActivityLogAssigment {
    DocumentType: string; // "Redlining",
    CreationDate: string; // "09.04.2024 11:06:00",
    UniversalId: string; // "DDBEAAF7343DF445C1258AFA0031FD28",
    Description: string; // "Redlining",
    Creator: string; // "Max Mustermann - EPLASS GmbH"
}
